<script setup>
/**
 * The builder's right panel: the Content/Design/Targeting tab strip and a
 * scrollable body that renders the active tab via a dynamic slot.
 */
import { useI18n } from 'vue-i18n';

const activeTab = defineModel('activeTab', { type: String, required: true });

const { t } = useI18n();

const TABS = ['content', 'design', 'targeting'];

const tabClasses = isActive => [
  'flex-1 h-8 rounded-lg font-medium text-label-small transition-colors',
  isActive
    ? 'bg-n-solid-active text-n-slate-12 shadow-sm outline outline-1 outline-n-container'
    : 'text-n-slate-11 hover:bg-n-alpha-1 hover:text-n-slate-12',
];
</script>

<template>
  <aside
    class="flex flex-col flex-shrink-0 w-96 min-h-0 border-l border-n-weak bg-n-solid-1"
  >
    <div
      role="tablist"
      class="flex items-center gap-1 p-2 border-b border-n-weak"
    >
      <button
        v-for="tab in TABS"
        :id="`builder-tab-${tab}`"
        :key="tab"
        type="button"
        role="tab"
        :aria-selected="activeTab === tab"
        :aria-controls="`builder-tabpanel-${tab}`"
        :class="tabClasses(activeTab === tab)"
        @click="activeTab = tab"
      >
        {{ t(`CAMPAIGN.BUILDER.TABS.${tab.toUpperCase()}`) }}
      </button>
    </div>

    <div
      :id="`builder-tabpanel-${activeTab}`"
      role="tabpanel"
      :aria-labelledby="`builder-tab-${activeTab}`"
      class="flex-1 min-h-0 p-4 overflow-y-auto"
    >
      <slot :name="activeTab" />
    </div>
  </aside>
</template>
